import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const AppFooter = () => (
  <Box
    component="footer"
    sx={{
      py: 2,
      px: 3,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderTop: '1px solid',
      borderColor: 'divider',
      opacity: 0.7,
    }}
  >
    <Typography variant="caption" color="text.secondary">
      &copy; 2025 Project Management System
    </Typography>
    <Typography variant="caption" color="text.secondary">
      Powered by{' '}
      <Link href="https://www.aiviz.me" target="_blank" rel="noopener noreferrer" color="primary">
        AIVIZ.me
      </Link>
    </Typography>
  </Box>
);

export default React.memo(AppFooter);
